<template>
    <div class="create-project">
        <b-modal id="project-modal" centered size="lg"  @show="loadCompanyUsers"
                 :title="steps[step].title + ' - ' + currentStep + '/' + (project.id ? (stepCount - 1) : stepCount )"
                 @cancel="onCancelProjectCreation">

            <b-form v-if="step === 0">
                <b-alert variant="info" show>This information will be shown in project view and in the reports.</b-alert>

                <b-form-group label="Project name" label-for="projects-index-name">
                    <b-form-input
                        id="projects-index-name"
                        v-model="project.name"
                        :state="errors.name"
                        @input="errors.name = null"
                        placeholder="Enter project name"
                        autofocus
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group label-for="projects-index-file">
                    <label>Project image (<em>jpeg or png files only</em>)</label>
                    <b-form-file id="projects-index-file" v-model="file"
                                 @input="onFileChanged"
                                 :state="Boolean(file)"
                                 placeholder="Choose a file or drop it here..."
                                 drop-placeholder="Drop file here..."></b-form-file>
                </b-form-group>

                <div class="col-sm-4">
                    <img :src="project.image" class="img-fluid">
                </div>
            </b-form>

            <b-form v-if="step === 1">
                <b-alert variant="info" show>This information will be shown in the reports</b-alert>

                <b-form-group label="Project description" label-for="projects-index-description">
                    <b-form-textarea id="projects-index-description"
                                     v-model="project.description"
                                     @input="errors.description = null"
                                     placeholder="Enter project description"
                                     rows="5"
                                     max-rows="6"
                    ></b-form-textarea>
                </b-form-group>
            </b-form>

            <b-form v-if="step === 2">
                <ul class="user-list">
                    <li v-for="user in users" v-bind:key="user.id">

                        <div class="form-check">
                            <input :id="'user_checkbox_' + user.id" class="form-check-input"
                                   type="checkbox" :value="user.id"
                                   :disabled="user.id === $store.state.user.id"
                                   :checked="(project.assigned_users.filter(assigned_user => assigned_user.id === user.id).length > 0) || user.id === $store.state.user.id"
                                   :ref="'user_checkbox_' + user.id"
                                   @change="assignedUserChange($event, user)"
                            >
                            <label class="form-check-label" :for="'user_checkbox_' + user.id">
                                {{ user.name }}
                            </label>
                        </div>
                    </li>
                </ul>
            </b-form>

            <b-form v-if="step === 3">

                <b-alert variant="info" show>This information will be shown in the reports</b-alert>

                <h3>Project details</h3>

                <b-form-group label="Project Location / Address" label-for="projects-index-address">
                    <b-form-input
                        id="projects-index-address"
                        v-model="project.address"
                        :state="errors.address"
                        @input="errors.address = null"
                        required
                        placeholder="Enter Project Location / Address"
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Project Objective / Scope" label-for="projects-index-scope">
                    <b-form-input
                        id="projects-index-scope"
                        v-model="project.scope"
                        :state="errors.scope"
                        @input="errors.scope = null"
                        required
                        placeholder="Example: Flat renovation"
                    ></b-form-input>
                </b-form-group>

                <h3>Customer details</h3>

                <b-form-group label="Customer Address" label-for="projects-index-contact_person_address">
                    <b-form-input
                        id="projects-index-contact_person_address"
                        v-model="project.contact_person_address"
                        :state="errors.contact_person_address"
                        @input="errors.contact_person_address = null"
                        required
                        placeholder="Enter Customer Address"
                    ></b-form-input>
                </b-form-group>


                <b-form-group label="Contact Person Name" label-for="projects-index-contact_person_name">
                    <b-form-input
                        id="projects-index-contact_person_name"
                        v-model="project.contact_person_name"
                        :state="errors.contact_person_name"
                        @input="errors.contact_person_name = null"
                        required
                        placeholder="Enter contact person name"
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Contact Person E-mail" label-for="projects-index-contact_person_email">
                    <b-form-input
                        id="projects-index-contact_person_email"
                        v-model="project.contact_person_email"
                        :state="errors.contact_person_email"
                        @input="errors.contact_person_email = null"
                        required
                        placeholder="Enter contact person email"
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Contact Person Phone Number" label-for="projects-index-contact_person_phone_number">
                    <b-form-input
                        id="projects-index-contact_person_phone_number"
                        v-model="project.contact_person_phone_number"
                        :state="errors.contact_person_phone_number"
                        @input="errors.contact_person_phone_number = null"
                        required
                        placeholder="Enter contact person phone number"
                    ></b-form-input>
                </b-form-group>
            </b-form>

            <b-form v-if="step === 4">
                <dl class="row">
                    <dt class="col-sm-6">Project name</dt>
                    <dd class="col-sm-6" v-text="project.name"></dd>

                    <dt class="col-sm-6">Project description</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.description"></dd>

                    <dt class="col-sm-6">Project address</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.address"></dd>

                    <dt class="col-sm-6">Project objective (scope)</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.scope"></dd>

                    <dt class="col-sm-6">Customer Address</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.contact_person_address"></dd>

                    <dt class="col-sm-6">Contact Person Name</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.contact_person_name"></dd>

                    <dt class="col-sm-6">Contact Person Email</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.contact_person_email"></dd>

                    <dt class="col-sm-6">Contact Person Phone Number</dt>
                    <dd class="col-sm-6 text-pre-wrap" v-text="project.contact_person_phone_number"></dd>

                    <dt class="col-sm-6">Project image</dt>
                    <dd class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-6">
                                <img v-if="project.image" :src="project.image" class="img-fluid">
                            </div>
                        </div>
                    </dd>
                </dl>
            </b-form>

            <template #modal-footer="{ cancel, ok }">

                <b-button @click="cancel">Cancel</b-button>

                <b-button v-if="step > 0" @click="prevStep" variant="primary">Back</b-button>

                <b-button v-if="step + 1 < stepCount" @click="nextStep"
                          variant="primary">Next
                </b-button>

                <b-button v-if="step + 1 >= stepCount" @click="saveProject(); ok()"
                          variant="primary">
                    <span v-if="project.id">Update</span>
                    <span v-else>Create</span>
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import {each, values} from 'lodash';
    import axios from 'axios';
    import '@css/settings-create-project.css';

    export default {
        props: {
            project: {
                type: Object,
                required: true
            }
        },
        data() {

            return {
                steps: [
                    { title: 'Basic Information' },
                    { title: 'Basic Information' },
                    { title: 'Users' },
                    { title: 'Project Details' },
                    { title: 'Summary' }
                ],
                step: 0,
                file: null,
                errors: {
                    name: null,
                    image: null,
                    address: null,
                    description: null,
                    scope: null,
                    contact_person_address: null,
                    contact_person_name: null,
                    contact_person_email: null,
                    contact_person_phone_number: null,
                },
                companies: [],
                projects: [],
                users: [],
                originalProject: {}
            }
        },
        computed: {
            stepCount() {
                if(!this.project.id){
                    return values(this.steps).length;
                }
                else{
                    return values(this.steps).length - 1;
                }
            },
            currentStep(){
                if(!this.project.id || this.step < 3){
                    return this.step + 1;
                }
                else{
                    return this.step;
                }
            },
            hasErrors() {
                let errors = false;

                each(this.errors, function (error) {
                    if (error === false) {
                        errors = true;
                    }
                });
                return errors;
            }
        },
        watch: {
            'project.id': function() {
                this.loadCompanyUsers();
            }
        },
        mounted() {
            if(this.project.id){
                this.originalProject = Object.assign({}, this.project);
            }
        },
        methods: {
            nextStep() {
                if (this.step === 0) {
                    if (!this.project.name) {
                        this.errors.name = false;
                    }
                } else if (this.step === 1) {
                }

                if(this.step === 1 && this.project.id){
                    this.step++;
                }

                if (this.hasErrors) {
                    return;
                }
                this.step++;
            },
            prevStep(){
                if(this.step === 3 && this.project.id){
                    this.step--;
                }
                this.step--;
            },

            loadCompanyUsers() {
                let token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/users',
                    method: 'GET',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.users = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            saveProject() {
                let token = this.$store.state.token;
                let url = this.project.id ? this.$store.getters.apiBase + '/projects/' + this.project.id : this.$store.getters.apiBase + '/projects'
                let method = this.project.id ? 'PUT' : 'POST'

                axios({
                    url: url,
                    data: this.project,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        let project = response.data.data;

                        this.$emit('projectSaved', project);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            assignedUserChange(event, user) {
                if (event.target.checked) {
                    this.project.assigned_users.push(user);
                } else {
                    this.project.assigned_users = this.project.assigned_users.filter(function (obj) {
                        return obj.id !== user.id;
                    });
                }
            },
            onCancelProjectCreation() {
                if(typeof this.project.id === 'undefined' || !this.project.id){
                    this.project.name = null;
                    this.project.description = null;
                    this.project.image = null;
                }
                else{
                    this.$emit('setProject', this.originalProject);
                }
                this.step = 0;
            },
            onFileChanged() {
                let reader = new FileReader();
                reader.addEventListener("load", () => {
                    this.project.image = reader.result;
                    console.log(this.project.image);

                    this.$forceUpdate();
                }, false);

                if (this.file) {
                    reader.readAsDataURL(this.file);
                }
            }
        }
    }
</script>
